import { Trans, useTranslation } from 'react-i18next';
import { Link, Text } from '@resideo/blueprint-react';
import React from 'react';
import { UserTerms } from './UserTerms';
import { createMessageHandler } from '../../../utils/createMessageHandler';

const ConsumerLinks = ({ viewTermsUrl, eulaUrl }) => {
  const messageHandler = createMessageHandler();

  const { t } = useTranslation();
  return (
    <UserTerms>
      <Text data-test-terms-conditions-label>{t('signUp.acceptTerms')}</Text>
      <Text>
        <Trans
          i18nKey='signUp.viewTermsConsumer'
          components={[
            <Link
              data-test-terms-link
              key={0}
              href={!messageHandler.hasMessageHandler ? viewTermsUrl : '#'}
              target='_blank'
              onClick={e => {
                if (messageHandler.hasMessageHandler) {
                  e.preventDefault();
                  // Signal mobile app to open link in external browser
                  messageHandler.postMessage('openExternalUrl', viewTermsUrl);
                }
              }}></Link>,
            <Link
              data-test-eula-link
              key={1}
              href={!messageHandler.hasMessageHandler ? eulaUrl : '#'}
              target='_blank'
              onClick={e => {
                if (messageHandler.hasMessageHandler) {
                  e.preventDefault();
                  // Signal mobile app to open link in external browser
                  messageHandler.postMessage('openExternalUrl', eulaUrl);
                }
              }}></Link>,
          ]}
        />
      </Text>
    </UserTerms>
  );
};

export default ConsumerLinks;
